export const nav = {
    permissao: 'hdocs.lotes:ver',
    section: 'Documentos',
    title: 'Lotes',
    icon: 'dynamic_feed',
    route: '/lotes',
    sequence: 3,
};

// "/lotes/novo" vem ANTES de "/lotes/:id": o router casa na ordem, e sem isso
// "novo" seria lido como o id de um lote.
export default [
    {
        path: '/lotes',
        name: 'lotes',
        component: () => import('./pages/LotesPage.vue'),
        meta: { requiresAuth: true, permissao: 'hdocs.lotes:ver' },
    },
    {
        path: '/lotes/novo',
        name: 'lote-novo',
        component: () => import('./pages/LoteNovoPage.vue'),
        meta: { requiresAuth: true, permissao: 'hdocs.lotes:criar' },
    },
    {
        path: '/lotes/:id',
        name: 'lote',
        component: () => import('./pages/LotePage.vue'),
        props: true,
        meta: { requiresAuth: true, permissao: 'hdocs.lotes:ver' },
    },
];
